import {defineMessages, FormattedMessage} from 'react-intl';
import {soundOn, soundOff} from '@sail/icons/react/Icon';
import {Action, Icon, Tooltip} from '@sail/ui';
import {useAnalytics} from '../../../AnalyticsProvider';
import {useWidgetNotifications} from '../../useWidget';

const messages = defineMessages({
  turnOn: {
    id: 'conversations_ui.widget.header.speakerButton.turnOn.label',
    description: 'Label used for the speaker button that turns sound on.',
    defaultMessage: 'Turn on',
  },
  turnOff: {
    id: 'conversations_ui.widget.header.speakerButton.turnOff.label',
    description: 'Label used for the spaeker button that turns sound off',
    defaultMessage: 'Turn off',
  },
});

export function SpeakerButton() {
  const analytics = useAnalytics();

  const {soundSetting, setSoundSetting} = useWidgetNotifications();

  const toggleSoundSetting = () => {
    // If it's possible to call this helper, then the speaker button must be showing (i.e. soundSetting !== 'disabled')
    const resultingSoundSetting = soundSetting === 'on' ? 'off' : 'on';

    setSoundSetting(resultingSoundSetting);
    analytics.action('toggle_speaker_button_clicked', {
      resultingSoundSetting,
    });
  };

  if (soundSetting === 'disabled') {
    // don't show the speaker button if setting is disabled
    return null;
  }

  let label;
  let icon;

  if (soundSetting === 'off') {
    label = messages.turnOn;
    icon = soundOff;
  } else {
    label = messages.turnOff;
    icon = soundOn;
  }

  return (
    <Tooltip
      type="label"
      trigger={
        <Action
          data-testId="conversations-widget-speaker-button"
          onPress={toggleSoundSetting}
          css={{paddingX: 'small'}}
        >
          <Icon icon={icon} size="xsmall" />
        </Action>
      }
    >
      <FormattedMessage {...label} />
    </Tooltip>
  );
}
